import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PromoterForm from '../../components/promoters/PromoterForm';
import PageTitle from '../../components/shared/PageTitle';

const AddPromoter: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <PageTitle title={t('promoters.addPage.pageTitle')} />
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm">
          <div className="border-b border-gray-200 p-6 bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-t-xl">
            <h1 className="text-2xl font-bold">{t('promoters.addPage.heading')}</h1>
            <p className="text-blue-100 mt-1">{t('promoters.addPage.subheading')}</p>
          </div>

          <div className="p-8">
            <PromoterForm onClose={() => navigate('/promoters')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPromoter;
